import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PythonInstall = makeShortcode("PythonInstall");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PythonInstall mdxType="PythonInstall" />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pip install posthog
`}</code></pre>
    <p>{`In your app, import the `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` library and set your project API key and host `}<strong parentName="p">{`before`}</strong>{` making any calls.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from posthog import Posthog


posthog = Posthog('<ph_project_api_key>', host='<ph_instance_address>')
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` As a rule of thumb, we do not recommend having API keys in plaintext. Setting it as an environment variable is best.`}</p>
    </blockquote>
    <p>{`You can find your project API key and instance address in the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{` page in PostHog.`}</p>
    <p>{`To debug, you can toggle debug mode:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`posthog.debug = True
`}</code></pre>
    <p>{`To make sure no calls happen during tests, you can disable PostHog, like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`if settings.TEST:
    posthog.disabled = True
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      